import { render, staticRenderFns } from "./modelWatchInfo.vue?vue&type=template&id=48208ab2&scoped=true&"
import script from "./modelWatchInfo.vue?vue&type=script&lang=js&"
export * from "./modelWatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./modelWatchInfo.vue?vue&type=style&index=0&id=48208ab2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48208ab2",
  null
  
)

export default component.exports